import { useState, useEffect } from "react";
import CustomCheckbox from "../../../Inputs/CustomCheckbox";
import CollapseItem from "../../../FormBuilder/components/CollapseItem";
// import { Rate } from "rsuite";

interface StoreFilterProps {
  mstags?: string[];
  onTagsChange?: (tags: string[]) => void;
  selectedTags: string[];
}

// const categoriesOptions = [
//   "App",
//   "Solutions",
//   "Learning",
//   "Integrations",
//   "Add-On",
//   "Service",
// ];

const StoreFilter = ({
  mstags,
  onTagsChange,
  selectedTags,
}: StoreFilterProps) => {
  const [filterQuery, setFilterQuery] = useState<{
    businessNeeds: string[];
    categories: string[];
    rate: number;
  }>({
    businessNeeds: [],
    categories: [],
    rate: 0,
  });

  useEffect(() => {
    setFilterQuery((prev) => ({ ...prev, businessNeeds: selectedTags }));
  }, [selectedTags]);

  const handleChangeFilter = ({
    filter,
    option,
  }: {
    filter: string;
    option: string | number;
  }) => {
    let newValues: string[];
    setFilterQuery((prev: any) => {
      if (filter === "rate") {
        return { ...prev, [filter]: option };
      }
      //@ts-ignore
      if (prev[filter].includes(option)) {
        //@ts-ignore
        newValues = prev[filter].filter((value: string) => value !== option);
      } else {
        //@ts-ignore
        newValues = [...prev[filter], option];
      }

      if (filter === "businessNeeds") {
        if (onTagsChange) {
          onTagsChange(newValues);
        }
      }
      //@ts-ignore
      return { ...prev, [filter]: newValues };
    });
  };

  const filters = [
    {
      key: "businessNeeds",
      title: "Business Needs",
      type: "dropdown",
      optionMenu: undefined,
      children: (
        <div className="tw:flex tw:flex-col tw:py-2 tw:px-4 tw:gap-1 tw:min-h-56 tw:max-h-[500px] tw:overflow-y-auto">
          {mstags?.map((tag) => {
            return (
              <CustomCheckbox
                key={tag}
                name={tag}
                checked={filterQuery.businessNeeds.includes(tag)}
                handleChange={() =>
                  handleChangeFilter({ filter: "businessNeeds", option: tag })
                }
                label={tag}
              />
            );
          })}
        </div>
      ),
    },
    // {
    //   key: "categories",
    //   title: "Categories",
    //   type: "dropdown",
    //   optionMenu: undefined,
    //   children: (
    //     <div className="tw:flex tw:flex-col tw:py-2 tw:px-4 tw:gap-1">
    //       {categoriesOptions.map((option, i) => {
    //         return (
    //           <CustomCheckbox
    //             key={i}
    //             name={option}
    //             checked={filterQuery.categories.includes(option)}
    //             handleChange={() =>
    //               handleChangeFilter({ filter: "categories", option })
    //             }
    //             label={option}
    //           />
    //         );
    //       })}
    //     </div>
    //   ),
    // },
    // {
    //   key: "rating",
    //   title: "Rating",
    //   type: "rating",
    //   optionMenu: undefined,
    //   children: (
    //     <div className="tw:flex tw:flex-col tw:py-2 tw:px-4 tw:gap-1">
    //       <CustomCheckbox
    //         name="5"
    //         checked={filterQuery.rate === 5}
    //         handleChange={() =>
    //           handleChangeFilter({ filter: "rate", option: 5 })
    //         }
    //         label={<Rate defaultValue={5} color="orange" size="xs" readOnly />}
    //       />
    //       <CustomCheckbox
    //         name="4"
    //         checked={filterQuery.rate === 4}
    //         handleChange={() =>
    //           handleChangeFilter({ filter: "rate", option: 4 })
    //         }
    //         label={<Rate defaultValue={4} color="orange" size="xs" readOnly />}
    //       />
    //       <CustomCheckbox
    //         name="3"
    //         checked={filterQuery.rate === 3}
    //         handleChange={() =>
    //           handleChangeFilter({ filter: "rate", option: 3 })
    //         }
    //         label={<Rate defaultValue={3} color="orange" size="xs" readOnly />}
    //       />
    //       <CustomCheckbox
    //         name="2"
    //         checked={filterQuery.rate === 2}
    //         handleChange={() =>
    //           handleChangeFilter({ filter: "rate", option: 2 })
    //         }
    //         label={<Rate defaultValue={2} color="orange" size="xs" readOnly />}
    //       />
    //       <CustomCheckbox
    //         name="1"
    //         checked={filterQuery.rate === 1}
    //         handleChange={() =>
    //           handleChangeFilter({ filter: "rate", option: 1 })
    //         }
    //         label={<Rate defaultValue={1} color="orange" size="xs" readOnly />}
    //       />
    //     </div>
    //   ),
    // },
  ];

  return (
    <div
      className="tw:w-1/6 tw:min-w-72 tw:shadow-md"
      style={{
        backgroundColor: "#F0F3F2",
      }}
    >
      <div className="tw:flex tw:flex-col">
        {filters.map((filter, i) => {
          return (
            <CollapseItem
              key={i}
              title={filter?.title}
              children={filter?.children}
              optionMenu={filter?.optionMenu}
              style={{
                backgroundColor: "white",
              }}
              className={"tw:border-t-1 tw:border-gray-50"}
            />
          );
        })}
      </div>
    </div>
  );
};

export default StoreFilter;
